import { call, takeLatest, put, takeEvery } from 'redux-saga/effects';
import CouponServices from 'shared/services/CouponServices';

import {
  createCouponData,
  getCouponData,
  setCouponData,
  actionFail,
  updateCouponSuccess,
  updateCouponFail,
  updateCouponData,
  buildCouponPage,
  setIndividualCouponInfo
} from './coupon.redux';

import { TAction, TPaginationRequest } from 'shared/types';

import { openNotificationMessage } from '../../shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';
import { AxiosResponse } from 'axios';

import { ICoupon } from 'shared/interfaces/coupon.interface';

function* getCoupon({ payload }: TAction<TPaginationRequest>) {
  try {
    const result: AxiosResponse<ICoupon[]> = yield call(
      CouponServices.getCouponInfo,
      payload
    );
    yield put(setCouponData(result));
  } catch (error) {
    console.log('error', error);
  }
}

function* createCoupon({ payload }: TAction<any>) {
  try {
    yield call(CouponServices.createCoupon, payload.couponData);
    yield put(getCouponData(payload?.pagination));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Coupon was successfully created.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield put(actionFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data.message || 'Coupon creation was unsuccessful.'
    });
  }
}

function* handleUpdateCoupon({ payload }: TAction<any>) {
  try {
    const result: AxiosResponse<ICoupon> = yield call(
      CouponServices.updateCoupon,
      payload
    );
    yield put(updateCouponSuccess(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Coupon was successfully updated.'
    });
  } catch (error: any) {
    yield put(updateCouponFail());
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message || 'Coupon updating was unsuccessful.'
    });
  }
}

function* buildIndividualPage({ payload }: TAction<any>) {
  try {
    const result: AxiosResponse<ICoupon[]> = yield call(
      CouponServices.getOneCoupon,
      payload.id
    );
    yield put(setIndividualCouponInfo(result));
  } catch (error) {
    console.log('error', error);
  }
}

function* Coupons() {
  yield takeLatest(getCouponData.type, getCoupon);
  yield takeEvery(createCouponData.type, createCoupon);
  yield takeEvery(updateCouponData.type, handleUpdateCoupon);
  yield takeLatest(buildCouponPage.type, buildIndividualPage);
}

export default Coupons;
